import {
  TUserPaginationOption,
  TRESPONSE_GET_TNA_STEP_APPROVAL_LIST,
  TTnaStepApprovalsFetchReason,
  TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS,
} from '@monorepo/types';

export type TTnaApprovalsState = {
  tnaStepApprovalList: {
    tnaStepApprovalList: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST;
    fetchReason: TTnaStepApprovalsFetchReason;
  } | null;
  tnaStepApprovalDetails: {
    tnaStepApprovalDetails: TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS;
    tosId: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number]['tosId'];
  } | null;
  tnaStepApprovalPendingList: {
    tnaStepApprovalPendingList: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST;
    fetchReason: TTnaStepApprovalsFetchReason;
  } | null;
  tnaStepApprovalPendingDetails: {
    tnaStepApprovalPendingDetails: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS;
    approvalId: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number]['tosId'];
  } | null;
  userPaginationOption: TUserPaginationOption;
};

export const TTnaApprovalsActionType = {
  GetTnaStepApprovalList: 'GET_TNA_STEP_APPROVAL_LIST ' as const,
  GetTnaStepApprovalListSuccess: 'GET_TNA_STEP_APPROVAL_LIST_SUCCESS' as const,
  GetTnaStepApprovalListFailure: 'GET_TNA_STEP_APPROVAL_LIST_FAILURE' as const,
  GetTnaStepApprovalDetails: 'GET_TNA_STEP_APPROVAL_DETAILS' as const,
  GetTnaStepApprovalDetailsSuccess: 'GET_TNA_STEP_APPROVAL_DETAILS_SUCCESS' as const,
  GetTnaStepApprovalDetailsFailure: 'GET_TNA_STEP_APPROVAL_DETAILS_FAILURE' as const,
  TnaStepApprovalRequest: 'TNA_STEP_APPROVAL_REQUEST' as const,
  TnaStepApprovalRequestSuccess: 'TNA_STEP_APPROVAL_REQUEST_SUCCESS' as const,
  TnaStepApprovalRequestFailure: 'TNA_STEP_APPROVAL_REQUEST_FAILURE' as const,
  GetTnaStepApprovalPendingList: 'GET_TNA_STEP_APPROVAL_PENDING_LIST ' as const,
  GetTnaStepApprovalPendingListSuccess: 'GET_TNA_STEP_APPROVAL_PENDING_LIST_SUCCESS' as const,
  GetTnaStepApprovalPendingListFailure: 'GET_TNA_STEP_APPROVAL_PENDING_LIST_FAILURE' as const,
  GetTnaStepApprovalPendingDetails: 'GET_TNA_STEP_APPROVAL_PENDING_DETAILS' as const,
  GetTnaStepApprovalPendingDetailsSuccess: 'GET_TNA_STEP_APPROVAL_PENDING_DETAILS_SUCCESS' as const,
  GetTnaStepApprovalPendingDetailsFailure: 'GET_TNA_STEP_APPROVAL_PENDING_DETAILS_FAILURE' as const,
  UpdateTnaStepApproval: 'UPDATE_TNA_STEP_APPROVAL' as const,
  UpdateTnaStepApprovalSuccess: 'UPDATE_TNA_STEP_APPROVAL_SUCCESS' as const,
  UpdateTnaStepApprovalFailure: 'UPDATE_TNA_STEP_APPROVAL_FAILURE' as const,
  SetUserPaginationOption: 'SET_TNA_ORDER_USER_PAGINATION_OPTION' as const,
};
